export const getInvoiceEdit = (state) => state.invoice.invoiceEdit
export const getInvoicesList = (state) => state.invoice.invoices
export const getRegisteredUsersList = (state) =>
  state.invoice.registeredUsersList
export const getLocation = (state) => state.router.location.pathname
export const getAttachedWorkShiftJournalIds = (state) =>
  state.invoice.attachedWorkShiftJournalIds
export const getWorkshiftJournalData = (state) =>
  state.workShiftUser.workshift_journal
